import React, { useState, useEffect } from 'react';
import { getBindableBrand, bindBrand } from '../../services/brandService';
import { Form, Select, Modal, message } from 'antd';
import _ from 'lodash';
const { Option } = Select;

function BrandBind(props) {
    const [form] = Form.useForm();
    const { onCancel, brandInfo, visible, bindSuccess } = props;
    const { name } = brandInfo || {}
    const [bindableBrand, setBindableBrand] = useState([]);
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    useEffect(() => {
        form.resetFields();
    }, [name]);

    function getBrandOption(keyword = '') {
        getBindableBrand(keyword).then(res => {
            setBindableBrand(res.data.brands || []);
        });
    }

    function handleSubmit() {
        form.validateFields().then((values) => {
            let otherNames = [name];
            const brandId = values.brandId;
            const brandInstance = getBrandInstance(brandId);
            if(brandInstance.otherNames && brandInstance.otherNames.length) {
                otherNames = brandInstance.otherNames.concat(otherNames);
            }
            bindBrand(brandId, otherNames).then(res => {
                setBindableBrand([]);
                message.success('绑定成功');
                bindSuccess && bindSuccess();
            }).catch(err => {
                message.error(err.message || '绑定失败');
            })
        });
    }

    function getBrandInstance(brandId) {
        return bindableBrand.find(e => e.id === brandId);
    }

    function handleSearch(value) {
        setBindableBrand([]);
        if(!value) return null;
        getBrandOption(value);
    }

    function handleCancel() {
        setBindableBrand([]);
        onCancel && onCancel();
    }
    
    return (
        <Modal
            visible={visible}
            okText="提交"
            cancelText="取消"
            onCancel={handleCancel}
            onOk={handleSubmit}
            destroyOnClose={true}
        >
            <Form {...formItemLayout} name='brand-bind-modal' form={form}>
                <Form.Item label="品牌">
                    {name || 'Test'}
                </Form.Item>
                <Form.Item label="管理品牌" name="brandId" rules={[{ required: true, message: '请选择要挂靠的品牌' }]}>
                    <Select
                        showSearch
                        allowClear
                        placeholder="搜索管理品牌"
                        filterOption={false}
                        autoClearSearchValue={true}
                        onSearch={_.debounce(handleSearch, 300)}
                    >
                        {bindableBrand.map((item) => {
                            return (
                                <Option key={item.name} value={item.id}>{item.name}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default BrandBind;